// https://www.iban.com/country-codes
export class AddressState {
  protected constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly title: string
  ) {}

  getId: () => number = () => this.id
  getName: () => string = () => this.name
  public getTitle: () => string = () => this.title
}
